import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { ApplicantsTableDefinitionZod } from '../tables';

type Arguments = {
    id: string;
};

const schemaApplicantAgreements = z.object({
    advertisementConsentAgreed: ApplicantsTableDefinitionZod.shape.advertisementConsentAgreed,
    advertisementConsentAgreedAt: ApplicantsTableDefinitionZod.shape.advertisementConsentAgreedAt,
    dataProtectionAgreed: ApplicantsTableDefinitionZod.shape.dataProtectionAgreed,
    dataProtectionAgreedAt: ApplicantsTableDefinitionZod.shape.dataProtectionAgreedAt,
    emailVerificationDaysLeft: z.number().nullable(),
    emailVerified: ApplicantsTableDefinitionZod.shape.emailVerified,
    emailVerifiedAt: ApplicantsTableDefinitionZod.shape.emailVerifiedAt,
});

export const schemaLoanRequestResolver_GetAgreements = z
    .object({
        applicant1: schemaApplicantAgreements,
        applicant2: schemaApplicantAgreements.nullable(),
    })
    .nullable();

export type SchemaLoanRequestResolver_GetAgreements = z.infer<typeof schemaLoanRequestResolver_GetAgreements>;

export type LoanRequestResolver_GetAgreements = Resolver<Arguments, SchemaLoanRequestResolver_GetAgreements>;
